import { render, staticRenderFns } from "./ResultCardContainer.vue?vue&type=template&id=464b8f48&"
import script from "./ResultCardContainer.vue?vue&type=script&lang=js&"
export * from "./ResultCardContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports